module.exports = global.config = {
  imagepath: {
    images: ' https://image.roboliza.com/images/',
    icons: ' https://image.roboliza.com/icons/'
  }
};
